import { FormField } from "@components/FormEngine/types";
import { MedicationsList, MedicationAllergiesList } from "./MedicationsList";
import ConfirmationRadioGroup from "../../common/ConfirmationRadioGroup";
import _ from "lodash";
import { Medication } from "../../../../types/MedicationTypes";
import { getRecordId } from "@utils/helpers";
import MedicationService from "../../../../../services/medicationService";
import { MedicationsData } from "../../../../types/PatientFormTypes";
import { FormState } from "../../FormContext/types";

export const medicationsSchema: FormField[] = [
  {
    title: "Are you currently taking any medications?",
    type: "custom",
    component: ConfirmationRadioGroup,
    name: "takingMedications",
    fieldProps: {
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
      listFieldName: "activeMedications",
      confirmationText: "Are you sure you want to remove all medications you have listed? This action will mark them as inactive upon saving and cannot be undone.",
      sx: { flexDirection: "row", gap: 1 },
    },
  },
  {
    title: "Active Medications",
    description: "Please list all medications you are currently taking.",
    type: "custom",
    component: MedicationsList,
    name: "activeMedications",
    conditional: {
      label: "takingMedications",
      values: [true],
    },
  },
  {
    title: "Are you allergic to any medications?",
    type: "custom",
    component: ConfirmationRadioGroup,
    name: "allergicToMedications",
    fieldProps: {
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
      listFieldName: "medicationAllergies",
      confirmationText: "Are you sure you want to remove all medication allergies you have listed? This action will clear the list upon saving and cannot be undone.",
      sx: { flexDirection: "row", gap: 1 },
      labelProps: {
				sx: { fontWeight: "bold", color: "text.primary" },
			},
    },
  },
  {
    title: "Medication Allergies",
    description: "Please list all medications you are allergic to.",
    type: "custom",
    component: MedicationAllergiesList,
    name: "medicationAllergies",
    conditional: {
      label: "allergicToMedications",
      values: [true],
    },
  },
];

export const handleRemoveMedications = async (data: MedicationsData, formState: FormState) => {
  console.log("Handling medication removal");
  const { patientId } = formState;

  // Handle medication deactivation
  if (data.takingMedications === false && !_.isEmpty(data.activeMedications)) {
    console.log("Deactivating medications");
    console.log(data.activeMedications);
    const deactivatePromises = data.activeMedications.map((med: Medication) => 
      MedicationService.updateMedication(patientId, { ...med, status: 'INACTIVE' })
    );
    await Promise.all(deactivatePromises);

    data.activeMedications = [];
  }

  // Handle allergy clearing
  if (data.allergicToMedications === false && !_.isEmpty(data.medicationAllergies)) {
    console.log("Clearing allergies");
    data.medicationAllergies = [];
  }
};
